import React, {useEffect, useState} from 'react';
import type {RowSelectionModel} from 'components/dataTable/types';
import {useLocalization} from 'localization';
import {useGetResourceWithRefresh} from 'api';
import {FlexBox, Spacer} from 'components';
import {Table} from 'schema';
import {useColumnConfigState} from 'schema/table/hooks/useColumnConfigState';
import {norafUpdateIgnorelistItemSchema} from '../functions/norafUpdateIgnorelistItemSchema';
import {norafUpdateIgnorelistItemTableConfig} from '../functions/norafUpdateIgnorelistItemTableConfig';
import {useGetNorafUpdatesIgnorelist} from '../hooks/useGetNorafUpdatesIgnorelist';
import {NorafIgnoredListSelectionAction} from './NorafIgnoredListSelectionActions';

export const NorafIgnoredList = () => {
  const {t} = useLocalization();
  const getter = useGetNorafUpdatesIgnorelist();

  const {resetPaginationModel} = useColumnConfigState(
    norafUpdateIgnorelistItemSchema.name,
  );

  useEffect(() => {
    resetPaginationModel();
  }, [resetPaginationModel]);

  const [selection, setSelection] = useState<RowSelectionModel>({
    type: 'include',
    ids: new Set(),
  });

  const {
    result: {data, status},
    refresh,
  } = useGetResourceWithRefresh(getter);

  return (
    <FlexBox>
      <Spacer height={2} />
      <Table
        schema={norafUpdateIgnorelistItemSchema}
        data={data ?? []}
        configuration={norafUpdateIgnorelistItemTableConfig}
        loading={status === 'Loading'}
        header={t('page.agents.noraf.ignores.title')}
        selection={selection}
        onSelectionChanged={setSelection}
      />

      <Spacer height={2} />

      <NorafIgnoredListSelectionAction
        selection={selection}
        postProcessing={() => {
          refresh();
        }}
        postSuccess={() => {
          setSelection({
            type: 'include',
            ids: new Set(),
          });
        }}
      />
    </FlexBox>
  );
};
